import { useDispatch } from "react-redux";

export function promisify(fn: Function, ...args: any[]) {
  return new Promise((resolve, reject) => {
    fn.apply(null, [...args, resolve, reject]);
  });
}

export function usePromisifyWithDispatch(fn: Function) {
  const dispatch = useDispatch();
  return (...args: any[]) => {
    return new Promise((resolve, reject) => {
      dispatch(fn.apply(null, [...args, resolve, reject]));
    });
  };
}
